{
  "version": 1,
  "asset_id": "1b76228a-d443-49f7-818c-0ce13d900037",
  "project_id": "ca7587fa-3476-4974-b258-69992cc9166e",
  "url": "/__l5e/assets-v1/1b76228a-d443-49f7-818c-0ce13d900037/werk-2.jpg",
  "r2_key": "a/v1/ca7587fa-3476-4974-b258-69992cc9166e/1b76228a-d443-49f7-818c-0ce13d900037/werk-2.jpg",
  "original_filename": "werk-2.jpg",
  "size": 117354,
  "content_type": "image/jpeg",
  "created_at": "2026-09-22T13:29:59Z"
}
